/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76206ResListItemOtherDataObjDataObj {
  
  /** 数据类型：text|image|video|voice|file */
  dataType?: string;
  
  /** 文件名称 */
  fileName?: string;
  
  /** 文件地址 */
  fileUrl?: string;
  
  /** 文件大小 */
  fileSize?: string;
  
  /** 操作人ID */
  operatorId?: string;
  
  /** 操作人昵称 */
  operatorName?: string;
  
};
    
  
    
export interface IAPI76206ResListItemOtherDataObj {
  
  /** 消息类型：annex_file:附件 */
  messageType?: string;
  
  /** 消息详情 ,OtherDataInfo */
  data?: IAPI76206ResListItemOtherDataObjDataObj;
  
};
    
  
    
export interface IAPI76206ResListItemSenderObj {
  
  /** 成员Id */
  userId?: string;
  
  /** 成员名称 */
  userName?: string;
  
  /** 成员头像 */
  userHeadUrl?: string;
  
  /** 真名 */
  realName?: string;
  
  /** 是否逾期 */
  isOverdue?: number;
  
};
    
  
    
export interface IAPI76206ResListItem {
  
  /** 消息唯一ID */
  messageId?: string;
  
  /** 文本内容 */
  content?: string;
  
  /** 发送时间 */
  sendTime?: string;
  
  /** 扩展信息 ,OtherData */
  otherData?: IAPI76206ResListItemOtherDataObj;
  
  /** 发送人信息 ,SendUserResult */
  sender?: IAPI76206ResListItemSenderObj;
  
};
    
  



export interface API76206Req {
  
  /** 房间Id */
  roomId?: string;
    
  /** 起始消息ID */
  nextMessageId?: string;
    
  /** 拉取消息数 */
  pageSize?: string;
    
};



export interface API76206Res {
  /** 数据列表 ,T  */
  list?: IAPI76206ResListItem[];
  /** 是否有后续消息  */
  hasNext?: boolean;
  /** 后续起始消息ID  */
  nextMessageId?: string;
  /** 拉取消息数  */
  pageSize?: number;
  
};


// 接口函数 76206 滚动查询聊天记录（左边）

export interface IUseGetAPI76206Return {
  /** 滚动查询聊天记录（左边）: 接口请求状态 */
  isAPI76206Loading: boolean;
  /** 滚动查询聊天记录（左边）: 接口请求返回数据 */
  dataAPI76206: API76206Res;
  /**  滚动查询聊天记录（左边）: 接口数据请求方法 */
  fetchAPI76206Data: (inputs: API76206Req, config?: YWRequestConfig) => Promise<API76206Res>;
  /** 滚动查询聊天记录（左边）: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76206 = ():IUseGetAPI76206Return => {
  let isMount = true;
  const [isAPI76206Loading, setIsAPI76206Loading] = useState(false);
  const [dataAPI76206, setDataAPI76206] = useState<API76206Res>({} as API76206Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/message/history`;

  const fetchAPI76206Data = async (inputs: API76206Req, config?: YWRequestConfig): Promise<API76206Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76206Req>) || {}) as API76206Req;
    
  
    if ( isMount ) {
      setIsAPI76206Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76206Res>(`${basePath}/yoaichat-web/chat/message/history?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76206(res || {} as API76206Res);
        setIsAPI76206Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76206Loading(false);
      }
      return false as unknown as API76206Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76206Loading,
    dataAPI76206,
    fetchAPI76206Data,
    requestUrl,
  }
}

